import { all, fork } from "redux-saga/effects";
import user from "./user";

import codeManagement from "./codeManagement";
import permissionManagement from "./permission-management/list";
import notice from "./notice/index";
import menuManagementRegist from "./menu-management/regist";
import settingPassword from "./setting/password";
import event from "./event/index";
import membership from "./membership/index";
import point from "./point/index";
import home from "./home";
import review from "./review/index";
import left from "./left";
import pay from "./pay";
export default function* rootSaga() {
  yield all([
    fork(user),
    fork(codeManagement),
    fork(permissionManagement),
    fork(notice),
    fork(menuManagementRegist),
    fork(settingPassword),
    fork(event),
    fork(membership),
    fork(point),
    fork(home),
    fork(review),
    fork(left),
    fork(pay),
  ]);
}
